import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'react-tooltip-lite';

import cn from 'classnames';

import './TooltipForElement.css';

const TooltipForElement = ({ className, text, children, mode, isOpen }) => {
  return (
    <Tooltip
      content={text}
      tagName="span"
      background={mode === 'white' ? '#ffffff' : '#31254b'}
      padding={mode === 'white' ? '16px' : '8px'}
      direction="down"
      distance={16}
      className={className}
      tipContentClassName={cn(
        'contentTooltip',
        mode === 'white' ? 'contentTooltip_white' : 'contentTooltip_black'
      )}
      isOpen={isOpen}
    >
      {children}
    </Tooltip>
  );
};

TooltipForElement.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.any,
  mode: PropTypes.string,
  isOpen: PropTypes.bool
};

export default TooltipForElement;
